import React from 'react';
import { InputStyle } from './style';

export default function InputRateio({ rateio, setRateio }) {
  return (
    <InputStyle>
      <p>Rateio</p>
      <input
        type="number"
        max={100}
        min={0}
        value={rateio}
        onChange={(e) => {
          setRateio(parseInt(e.target.value, 10));
        }}
      />
    </InputStyle>
  );
}
